import classNames from "classnames";
import {Localizer} from "../../../infrastructure/localization/localizer";
import MultiLevelPieChart from "../dashboardCharts/multiLevelPieChart";
import React, {useState} from "react";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import {Loading} from "../../../core/components/loading/loading";
import useDashboardUddannelsesleager from "./useDashboardUddannelsesleager";
import {EmblaIllustration} from "../../../core/components/emblaIcon/emblaIllustration";
import DashboardCardSettings from "../dashboardCardSettings";
import {DashboardCardSettingsOption} from "../models/DashboardCardSettingsOption";
import {LegendPlacement} from "../models/LegendPlacement";

type DashboardUddannelseslaegerProps = {}
const DashboardUddannelseslaeger = ({}: DashboardUddannelseslaegerProps) => {
    const {isMobile} = useScreenResolution();
    const [showLabelsUddannelseslaeger, setShowLabelsUddannelseslaeger] = useState<boolean>(false);
    const {pieChart, isLoading, dataAmount} = useDashboardUddannelsesleager();

    const noResults = dataAmount <= 0 && !isLoading;

    const settingsOption: DashboardCardSettingsOption = {
        checkedValue: showLabelsUddannelseslaeger,
        setCheckedValue: setShowLabelsUddannelseslaeger,
        label: Localizer.dashboard_showLabelValues()
    };

    return <>
        <div className={classNames("card", !isMobile && "w-50")}>
            <div className="card-header">
                <h4 className="card-title">{Localizer.global_uddannelseslaeger()}</h4>
                <DashboardCardSettings id={"settings-uddannelseslaeger-icon-id"}
                                       options={[settingsOption]}/>
            </div>
            <div className={classNames("card-body")}>
                <Loading isLoading={isLoading} text={Localizer.global_uddannelseslaeger()} hideContentOnPreload={false}>
                    {noResults
                        ?
                        <div className={"flex-container-column align-items-center justify-content-center"}>
                            <EmblaIllustration illustrationName={"failure-mark"} additionalClasses={"subtle"}/>
                            <h4 className={"subtle"}> {Localizer.global_NoResultsFromFilter()} </h4>
                        </div>
                        :
                        <MultiLevelPieChart datasets={pieChart}
                                            totalAmount={dataAmount}
                                            showCenterLabel
                                            showLabels={showLabelsUddannelseslaeger}
                                            legendPlacement={LegendPlacement.Right}
                                            fullLegendWidth
                                            labelText={Localizer.global_uddannelseslaeger()}/>
                    }
                </Loading>
            </div>
        </div>
    </>
}
export default DashboardUddannelseslaeger;
